import { AiToolImpl } from "@me8eon/aiclient";
import { WidgetMeta } from "@me8eon/ai.tools.utils/src/widget";

type ToolArgs = Record<string, never>;
type ToolImpl = AiToolImpl<ToolArgs>;
type Tool = () => ToolImpl;

export const DisplayRequestCallbackActionToolImpl: Tool = () => {
    return {
        type: "service_api",
        toolDefn: {
            type: "function",
            name: "display_request_callback_action",
            description:
                "This tool displays a request callback widget for ServiceNow. Here user can request a callback.",
            parameters: {
                type: "object",
                properties: {},
                required: [],
                additionalProperties: false,
            }
        },
        execute: async (_options, _args) => {
            const widgetMeta: WidgetMeta = {
                name: "request_callback_widget",
                title: "Request Callback in ServiceNow",
                description: "Displays a widget to request a callback in ServiceNow",
                type: "widget",
                componentName: "RequestCallbackActionWidget",
                props: {}
            };

            return {
                _meta: {
                    widget: widgetMeta,
                    skipAiSummary: true
                },
                value: "Displaying Request Callback Widget"
            };
        }
    };
};